import {propsTypes} from './sprite-types'
export default [
    {
        name: '音频URL',
        type:propsTypes.string,
        key:'audio',
        value:''
    },
    {
        name: '视频URL',
        type: propsTypes.string,
        key:'video',
        value:''
    },
    {
        name: '自动播放',
        type: propsTypes.switch,
        key:'autoPlay',
        value:false
    },
    {
        name: '循环播放',
        type: propsTypes.switch,
        key:'playLoop',
        value:false
    },
    {
        name: '播放下一个',
        type: propsTypes.string,
        key:'nextAnimate',
        value:''
    },
]